import React, { useEffect } from 'react'
import { styled } from 'linaria/react'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { theme } from '../Theme'
import { Cancel as CancelIcon, Download } from 'iconoir-react'
import Title from './Title'

const StyledDrawer = styled(Drawer)`
   overflow-y: unset !important;
   width: 95vw !important;
   height: 100% !important;
   border-radius: 2rem 0rem 0rem 0rem;
   background-color: ${props => props.backgroundColor} !important;
   z-index: 1030;

   & .drawer-header {
      margin: 0.5rem 1rem 0.5rem 1.3rem
   }
   
   .menu-drawer-title {
      margin-top: -3px;
      ${theme.below.lg} {
         font-size: 1rem;
         margin-top: 0;
      }
   }

   .cancel-icon {
      cursor: pointer;
      ${theme.below.lg} {
         height: 1.75rem;
         width: 1.75rem;
         /* margin-top: 2px; */
      }
   }

   ${theme.below.lg} {
      #download-icon { 
         height: 1.3em;
      }
   }

   .file-info-action {
      display: flex;
      justify-items: center;
      & > :first-child {
         padding-left: 0.5rem;
         padding-right: 0.5rem;
         border-left: 1px solid #cacaca;
         border-right: 1px solid #cacaca;
      }
      & > :nth-child(2) {
         margin-left: 0.5rem;
      }
      ${theme.below.lg} {
         height: 1.75rem;
         width: 1.75rem;
      }
   }

   .cancel-icon:hover {
      opacity: 0.75;
      transition: opacity 0.5s ease;
   }

   a {
      text-decoration: none;
   }

   a:hover {
      opacity: 0.75;
      transition: opacity 0.5s ease;
   }
`

const VbDrawerPdf = ({
   isOpen,
   setIsOpen,
   titleIcon,
   backgroundColor,
   overrideDefault,
   title,
   iframeUrl,
   className,
   children,
   ...props
}) => {
   const toggleDrawer = () => {
      setIsOpen(prevState => !prevState)
   }

   useEffect(() => {
      // Add/remove the "prevent-body-scroll" class to the body element
      document.body.classList.toggle('prevent-body-scroll', isOpen)

      // Cleanup function to remove the class when the component unmounts
      return () => {
         document.body.classList.remove('prevent-body-scroll')
      }
   }, [isOpen])

   return (
      <StyledDrawer
         backgroundColor={backgroundColor ?? '#e9e9e9'}
         open={isOpen}
         onClose={toggleDrawer}
         direction="right"
         className={`${className}`}
         {...props}
      >
         <>
            <div className="drawer-header d-flex justify-content-between align-items-center">
               <div className="d-flex gap-4 align-items-center">
                  <Title
                     size="1.3rem"
                     fontFamily="Industry"
                     weight={600}
                     className="menu-drawer-title"
                  >
                     {title}
                  </Title>
                  <div className="file-info-action">
                  <div>{titleIcon}</div>
                     <a href={iframeUrl} target="_blank" rel="noreferrer">
                        <Download
                           id="download-icon"
                           strokeWidth={2.0}
                           height={'1.3em'}
                           color="#000000"
                        ></Download>
                     </a>
                  </div>
               </div>

               <CancelIcon
                  strokeWidth={2.0}
                  width={44}
                  height={44}
                  className="cancel-icon"
                  onClick={() => setIsOpen(!isOpen)}
               ></CancelIcon>
            </div>
            {children}
         </>
      </StyledDrawer>
   )
}

export default VbDrawerPdf
